<div class="bw-dialog attribute-dialog">

  <lib-page-header
      [screenName]="data.type"
      [title]="isEdit ? 'Edit attribute' : 'New attribute'"
      backTo="">
    <mat-icon icon>{{ isEdit ? 'edit' : 'add' }}</mat-icon>
    <ng-container actions>
      <button mat-icon-button (click)="cancel()" matTooltip="Close" aria-label="Close">
        <mat-icon>close</mat-icon>
      </button>
    </ng-container>
  </lib-page-header>

  <div class="bw-body">
    <form [formGroup]="form" autocomplete="off" novalidate class="form-grid">

      <mat-form-field appearance="outline">
        <mat-label>Name</mat-label>
        <input matInput formControlName="name" placeholder="e.g. firmware" maxlength="80" required />
        <mat-icon matPrefix>label</mat-icon>
        <mat-hint *ngIf="!isEdit">Logical name for this attribute. Used as the column heading wherever this field surfaces.</mat-hint>
        <mat-hint *ngIf="isEdit">Names are immutable — delete the rule and create a new one to rename.</mat-hint>
        <mat-error *ngIf="form.controls['name'].invalid">Name is required (max 80 chars)</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Payload path (JSONPath)</mat-label>
        <input matInput formControlName="payloadPath" placeholder="$.firmware" maxlength="255" required />
        <mat-icon matPrefix>data_object</mat-icon>
        <mat-hint *ngIf="!isEdit">JSONPath into the user_data.payload column. Sample: <code>$.firmware</code> or <code>$.network.vlan</code>.</mat-hint>
        <mat-hint *ngIf="isEdit">Payload paths are immutable.</mat-hint>
        <mat-error *ngIf="form.controls['payloadPath'].invalid">Payload path is required</mat-error>
      </mat-form-field>

      <div class="row two-col">
        <mat-form-field appearance="outline">
          <mat-label>Value type</mat-label>
          <mat-select formControlName="valueType" required>
            <mat-option *ngFor="let v of VALUE_TYPES" [value]="v.value">
              <mat-icon class="select-icon">{{ v.icon }}</mat-icon>
              {{ v.label }}
            </mat-option>
          </mat-select>
          <mat-icon matPrefix>category</mat-icon>
        </mat-form-field>

        <div class="toggle-cell">
          <mat-slide-toggle formControlName="indexed">Indexed</mat-slide-toggle>
          <span class="toggle-hint">Build a search index — query speed-up on this attribute.</span>
        </div>
      </div>

      <div class="toggle-cell">
        <mat-slide-toggle formControlName="readOnly">Read-only</mat-slide-toggle>
        <span class="toggle-hint">Lock the field on the UserData edit screen so operators can't modify it — useful for values pulled from upstream systems (vendor, firmware, model).</span>
      </div>

      <mat-form-field appearance="outline">
        <mat-label>Description (optional)</mat-label>
        <textarea matInput formControlName="description" rows="2" maxlength="500"
                  placeholder="What this attribute means to operators"></textarea>
        <mat-icon matPrefix>notes</mat-icon>
      </mat-form-field>

      <div *ngIf="errorMessage" class="error-banner">{{ errorMessage }}</div>
    </form>
  </div>

  <mat-dialog-actions align="end">
    <button mat-button (click)="cancel()" [disabled]="saving">Cancel</button>
    <button mat-flat-button color="primary" (click)="save()" [disabled]="saving || form.invalid">
      <mat-icon>save</mat-icon>
      Save
    </button>
  </mat-dialog-actions>
</div>
